// extracted by mini-css-extract-plugin
module.exports = {"button":"AccionaUploadButton_button__3Vj-w"};